module.exports = __webpack_public_path__ + "img/thumbnail_KomodoDragon_j_normal.5446b0f1.png";